var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"firstBanner"}},[_c('div',[_c('img',{staticClass:"w-100 h-100",attrs:{"src":"/img/home/DundasWestSkyline.jpg","alt":"A shot of Dundas West city scape."}})])])
}]

export { render, staticRenderFns }